import { render, staticRenderFns } from "./BusinessProductItemForm.vue?vue&type=template&id=4eafcd41"
import script from "./BusinessProductItemForm.vue?vue&type=script&lang=js"
export * from "./BusinessProductItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports